export const faClockTwoClassic = [
  '640 512',
  '<path d="M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm24-392l0 91.2 58.7-39.1c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3l-96 64c-7.4 4.9-16.8 5.4-24.6 1.2S232 264.9 232 256l0-136c0-13.3 10.7-24 24-24s24 10.7 24 24z"/>'
]
